<template>
  <div>
    <v-progress-circular :size="110" :width="10" color="primary" indeterminate />
  </div>
</template>

<style scoped>
div {
  display: flex;
  justify-content: center;
}
</style>